import { render, staticRenderFns } from "./DetailsRtaDealing.vue?vue&type=template&id=0fb4bc02&scoped=true&"
import script from "./DetailsRtaDealing.vue?vue&type=script&lang=js&"
export * from "./DetailsRtaDealing.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRtaDealing.vue?vue&type=style&index=0&id=0fb4bc02&prod&lang=css&"
import style1 from "./DetailsRtaDealing.vue?vue&type=style&index=1&id=0fb4bc02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb4bc02",
  null
  
)

export default component.exports